import React from "react";

export const Play = props => {
  return (
    <svg
      className={props.reference}
      id="play"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80.5 80.5"
    >
      <path
        d="M1.25 40.25a39 39 0 1 1 39 39 39 39 0 0 1-39-39zm30.46 20.91l28.16-19.53a1.94 1.94 0 0 0 0-3.41L31.71 18.7c-1.36-.94-2.46-.36-2.46 1.3v39.85c0 1.67 1.1 2.25 2.46 1.31z"
        strokeWidth="2.5"
      />
    </svg>
  );
};

export const Facebook = props => {
  return (
    <svg
      className={props.reference}
      id="facebook"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.83 28.35"
    >
      <path d="M13.83 4.63h-3.45s-1.76 0-1.76 1.55v4h5.17v4.89H8.62v13.28H3.55V15.11H0v-4.89h3.55v-4c0-.41-.06-3 1.42-4.51S7.43 0 8.38 0h5.45z" />
    </svg>
  );
};

export const Arrow = props => {
  return (
    <svg
      className={props.reference}
      id="arrow"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19.08 10.6"
    >
      <title>down</title>
      <path
        d="M241,189.9l-7.83-7.83-8,8a1,1,0,0,1-1.41-1.41l8.72-8.66a1,1,0,0,1,1.41,0l8.54,8.54A1,1,0,0,1,241,189.9Z"
        transform="translate(-223.52 -179.71)"
      />
    </svg>
  );
};

export const Close = props => {
  return (
    <svg
      className={props.reference}
      id="close"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 612 610.79"
    >
      <path d="M612 35.4L576.52 0 306 270 35.48 0 0 35.4l270.52 270.01L0 575.39l35.48 35.4L306 340.81l270.52 269.98 35.48-35.4-270.54-269.98L612 35.4z" />
    </svg>
  );
};

export const Email = props => {
  return (
    <svg
      className={props.reference}
      id="email"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.41 22.21"
    >
      <path d="M26.09 0H3.31A3.32 3.32 0 0 0 0 3.31V18.9a3.32 3.32 0 0 0 3.31 3.31h22.78a3.32 3.32 0 0 0 3.31-3.31V3.31A3.32 3.32 0 0 0 26.09 0zm1.48 3.31V18.9a1.46 1.46 0 0 1 0 .23l-7.95-7.23 7.94-8.68s.01.06.01.09zM1.83 18.9V3.31v-.1l7.95 8.69-7.92 7.23a1.47 1.47 0 0 1-.03-.23zm15-6.62a2.84 2.84 0 0 1-2.09.91 2.83 2.83 0 0 1-2.08-.91L3.08 1.86H26.32zm-5.77 1l.25.28a4.61 4.61 0 0 0 6.87 0l.25-.27 7.8 7.12h-23z" />
    </svg>
  );
};

export const Instagram = props => {
  return (
    <svg
      className={props.reference}
      id="instagram"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30.13 30.97"
    >
      <defs>
        <style>.cls-1{}</style>
      </defs>
      <path
        className="cls-1"
        d="M21.29 31H8.85A8.86 8.86 0 0 1 0 22.12V8.85A8.86 8.86 0 0 1 8.85 0h12.44a8.86 8.86 0 0 1 8.85 8.85v13.27A8.86 8.86 0 0 1 21.29 31zM8.85 2.27a6.59 6.59 0 0 0-6.58 6.58v13.27a6.59 6.59 0 0 0 6.58 6.58h12.44a6.59 6.59 0 0 0 6.58-6.58V8.85a6.59 6.59 0 0 0-6.58-6.58z"
      />
      <path
        className="cls-1"
        d="M15.07 23.67a8.24 8.24 0 0 1-8.23-8.23 8.37 8.37 0 0 1 2.52-6 7.85 7.85 0 0 1 5.75-2.26c5.08.15 8.29 3.39 8.19 8.26a8.25 8.25 0 0 1-8.23 8.23zM14.88 10a5.12 5.12 0 0 0-3.58 1.48 5.58 5.58 0 0 0-1.68 4 5.46 5.46 0 1 0 10.91 0c.07-3.29-2-5.32-5.5-5.43z"
      />
      <circle className="cls-1" cx="23.49" cy="6.98" r="1.92" />
    </svg>
  );
};

export const Share = props => {
  return (
    <svg
      className={props.reference}
      fill="#FFF"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
    >
      <path d="M78.284 21.716c-5.467-5.468-14.332-5.468-19.799 0l-5.657 5.656a2 2 0 0 0 2.829 2.829l5.656-5.657c3.905-3.905 10.237-3.905 14.143 0s3.905 10.236 0 14.143l-16.971 16.97c-3.905 3.905-10.236 3.905-14.142 0a2 2 0 0 0-2.829 2.828c5.468 5.468 14.331 5.468 19.799 0l16.971-16.971c5.468-5.467 5.468-14.33 0-19.798z"/>
      <path d="M47.171 69.799a2 2 0 0 0-2.828 0l-5.657 5.657c-3.906 3.905-10.237 3.905-14.143 0-3.905-3.906-3.905-10.236 0-14.143l16.971-16.971c3.906-3.905 10.236-3.905 14.143 0a2 2 0 1 0 2.828-2.828c-5.468-5.468-14.332-5.468-19.799 0l-16.97 16.971c-5.468 5.468-5.468 14.331 0 19.799s14.331 5.468 19.799 0l5.657-5.657a1.999 1.999 0 0 0-.001-2.828z"/>
    </svg>
  );
};

export const Twitter = props => {
  return (
    <svg
      className={props.reference}
      id="twitter"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 27.01 21.95"
    >
      <path d="M27 2.6a11.18 11.18 0 0 1-3.18.87A5.55 5.55 0 0 0 26.27.4a11.07 11.07 0 0 1-3.52 1.35 5.55 5.55 0 0 0-9.59 3.79 5.43 5.43 0 0 0 .14 1.26A15.72 15.72 0 0 1 1.88 1a5.46 5.46 0 0 0-.75 2.8A5.54 5.54 0 0 0 3.6 8.41a5.51 5.51 0 0 1-2.51-.69v.07a5.55 5.55 0 0 0 4.45 5.43 5.57 5.57 0 0 1-1.46.2 5.36 5.36 0 0 1-1-.1 5.55 5.55 0 0 0 5.18 3.85 11.11 11.11 0 0 1-6.88 2.37A10.57 10.57 0 0 1 0 19.46 15.66 15.66 0 0 0 8.5 22 15.66 15.66 0 0 0 24.26 6.18v-.72A11.26 11.26 0 0 0 27 2.6" />
    </svg>
  );
};

export const Vimeo = props => {
  return (
    <svg
      className={props.reference}
      id="vimeo"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26.77 23.24"
    >
      <path d="M25.51 9.5c-2.72 5.82-9.3 13.74-13.45 13.74S7.37 14.5 5.13 8.69C4 5.83 3.32 6.48 1.26 7.93L0 6.31C3 3.66 6 .59 7.87.42q3.13-.3 3.84 4.27c.64 4 1.52 10.23 3.07 10.23 1.2 0 4.17-4.94 4.33-6.7.27-2.58-1.9-2.66-3.78-1.85C18.3-3.4 30.71-1.6 25.51 9.5z" />
    </svg>
  );
};

export const Youtube = props => {
  return (
    <svg
      className={props.reference}
      id="youtube"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28.43 20.03"
    >
      <path d="M27.84 3.13A3.57 3.57 0 0 0 25.33.6C23.11 0 14.22 0 14.22 0S5.33 0 3.11.6A3.57 3.57 0 0 0 .59 3.13 37.48 37.48 0 0 0 0 10a37.48 37.48 0 0 0 .59 6.89 3.57 3.57 0 0 0 2.51 2.53c2.22.6 11.11.6 11.11.6s8.89 0 11.11-.6a3.57 3.57 0 0 0 2.51-2.53 37.48 37.48 0 0 0 .6-6.89 37.48 37.48 0 0 0-.59-6.87zM11.31 14.24V5.79L18.74 10z" />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/components/General/Svgs/SVGs.js